module.exports = __webpack_public_path__ + "img/sunmi_banner.76f6fdfd.jpg";